/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerDetails } from '../models/CustomerDetails';
import type { CustomerUpdate } from '../models/CustomerUpdate';
import { request as __request } from '../core/request';

export class CustomerVService {

    /**
     * @param billingAccountId
     * @param customerId
     * @param requestBody
     * @returns CustomerDetails OK
     * @throws ApiError
     */
    public static async customerVUpdate(
        billingAccountId: string,
        customerId: string,
        requestBody?: CustomerUpdate,
    ): Promise<CustomerDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/billing_accounts/${billingAccountId}/customers/${customerId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

}